import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';
import { CardContent, Typography, useTheme } from '@mui/material';
import ProductCard from '../../../ui/cards/productCard';
import CategoryOutlinedIcon from '@mui/icons-material/CategoryOutlined';
import { useNavigate } from 'react-router-dom';
import FCard from '../../../ui/fairtreeComponents/card/fCard';
import FCardHeader from '../../../ui/fairtreeComponents/card/fCardHeader';

const Products = ({ account, admin, advisor, broker, hasActiveSanneAcc }) => {
  const navigate = useNavigate();
  const theme = useTheme();

  const getNavigateTo = (row) => {
    if (admin) {
      return `/admin/client/account/${row.accountNumber}`;
    }

    if (advisor) {
      return `/advisor/client/account/${row.accountNumber}`;
    }

    if (broker) {
      return `/brokerhouse/client/account/${row.accountNumber}`;
    }

    return `/account/${row.accountNumber}`;
  };

  return (
    <Fragment>
      <Box display={'flex'} justifyContent={'start'} alignSelf={'start'}>
        <CategoryOutlinedIcon />
        <Typography ml={1} mb={1} variant="h5">
          Products
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center" mb={3}>
        {hasActiveSanneAcc && (
          <FCard raised={false}>
            <FCardHeader
              title={
                <Typography sx={{ lineHeight: 1, fontWeight: 'bold' }}>Investments</Typography>
              }
              subheader={
                <Box display="flex" flexDirection={'column'}>
                  <Typography variant="body1" sx={{ fontSize: '12px', fontWeight: 'bold' }}>
                    Administered by Apex{' '}
                  </Typography>
                </Box>
              }
            />

            <CardContent sx={{ pt: 1 }}>
              <Box display="flex" flexDirection="column" width="100%">
                <Typography
                  component="span"
                  sx={{
                    fontSize: '12px',
                    fontStyle: 'italic'
                  }}>
                  <span style={{ fontWeight: 600, color: theme.palette.accent.main }}>
                    Temporary Update on Investment Balances:
                  </span>{' '}
                  Please note that current Apex investment balance information is temporarily
                  unavailable on the portal. Our Fund Administrator, Apex Group, is currently
                  migrating to a new system to enhance reporting and service quality. In the
                  meantime, you can refer to your latest investor statement (sent to you via email)
                  for accurate balance details.
                </Typography>

                <Typography
                  sx={{
                    fontSize: '12px',
                    fontStyle: 'italic',
                    mt: 1
                  }}>
                  If you require further assistance, please contact your financial advisor or our
                  Client Services team.
                </Typography>
              </Box>
            </CardContent>
          </FCard>
        )}
        {account.balances.map((row, index) =>
          row.administratorMaintenance ? (
            <FCard>
              <FCardHeader title={row.administrator + ' Undergoing Maintenance'} />
              <CardContent>
                <Typography variant="body1">
                  {row.administrator} is currently undergoing maintenance. Please check back later.
                </Typography>
              </CardContent>
            </FCard>
          ) : (
            <ProductCard
              accountNumber={row.accountNumber}
              administrator={row.administrator}
              model={row.model}
              product={row.product}
              onClick={() => navigate(getNavigateTo(row))}
              closingDate={row.funds[0].closingDate}
              key={index}
            />
          )
        )}
      </Box>
    </Fragment>
  );
};

Products.propTypes = {
  account: PropTypes.object.isRequired,
  admin: PropTypes.bool
};

export default Products;
